var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.canPlay),expression:"canPlay"}],ref:"video",staticClass:"w-full h-full object-cover",class:{ 'scale-x-flip': _vm.mirror }})}
var staticRenderFns = []

export { render, staticRenderFns }